import moment from 'moment-timezone';

export const getIsButtonEnabled = (data, errors) => {
  if (Object.values(data).some((v) => !v) || Object.values(errors).some((e) => e)) return false;

  return true;
};

export const validateScheduleTime = (datetime, timeZone) => {
  let errMsg = '';

  if (!datetime) {
    errMsg = 'Scheduled time should not be empty';
    return { scheduledTime: errMsg };
  }

  const now = moment.tz(timeZone);
  const target = moment.tz(datetime, 'YYYY-MM-DD HH:mm:ss', timeZone);

  if (target.isBefore(now)) {
    errMsg = 'The scheduled time is in the past. Please select a future time.';
    return { scheduledTime: errMsg };
  }

  const targetUtc = target.clone().utc();
  const targetUtcHour = targetUtc.hour();
  const targetUtcMinute = targetUtc.minute();
  const targetUtcTime = targetUtc.format('HH:mm');
  const isOutsideAllowedUtcHours = targetUtcHour < 6 || targetUtcHour > 23;
  const isAfterLastAllowedMinute = targetUtcHour === 23 && targetUtcMinute > 0;

  if (isOutsideAllowedUtcHours || isAfterLastAllowedMinute) {
    errMsg = `Your selected time in UTC is ${targetUtcTime}. Allowed range is 06:00-23:00 UTC.`;
  }

  return { scheduledTime: errMsg };
};
